import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-seguimiento-asistencia',
  templateUrl: './seguimiento-asistencia.component.html',
  styleUrls: ['./seguimiento-asistencia.component.css']
})
export class SeguimientoAsistenciaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
